// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_h6-a";
export var fulfillmentFormRail = "_h6-9";
export var headerTitleRow = "_h6-c";
export var orderDetailsWrapper = "_h6-7";
export var orderLinkTrigger = "_h6-2";
export var paymentInformationGrid = "_h6-h";
export var paymentSummaryColumn = "_h6-i";
export var shipmentContainer = "_h6-b";
export var shipmentDetailsMainPane = "_h6-8";
export var shipmentNavigationCard = "_h6-5";
export var shipmentNavigationRail = "_h6-3";
export var shipmentNavigationRailHeader = "_h6-4";
export var shipmentSummaryFact = "_h6-e";
export var shipmentSummaryGrid = "_h6-d";
export var shipmentSummaryMetadataRow = "_h6-f";
export var shipmentSummaryTags = "_h6-g";
export var shipmentWorkspace = "_h6-0";
export var shipmentWorkspaceContent = "_h6-6";
export var shipmentWorkspaceHeader = "_h6-1";